import { type Component, For, Show } from "solid-js";
import { CheckCircle2, XCircle, User, Bot } from "lucide-solid";
import type { ChatMessage as Msg } from "../../lib/types";

interface Props {
  message: Msg;
}

export const ChatMessage: Component<Props> = (props) => {
  const isUser = () => props.message.role === "user";
  const isAssistant = () => props.message.role === "assistant";
  const isTool = () => props.message.role === "tool";

  return (
    <div
      class="flex gap-2"
      classList={{
        "justify-end": isUser(),
        "justify-start": !isUser(),
      }}
    >
      <Show when={!isUser() && !isTool()}>
        <div class="flex-shrink-0 mt-1">
          <Bot class="h-5 w-5 text-primary" />
        </div>
      </Show>
      <div
        class="max-w-[80%] rounded-lg px-3 py-2 text-sm whitespace-pre-wrap break-words"
        classList={{
          "bg-primary text-primary-foreground": isUser(),
          "bg-muted text-foreground": isAssistant(),
          "bg-amber-50 border border-amber-200 text-amber-900 text-xs": isTool(),
        }}
      >
        <Show when={isTool() && props.message.name}>
          <div class="font-mono text-[10px] mb-1 opacity-70">tool:{props.message.name}</div>
        </Show>
        <div>{props.message.content}</div>
        <Show when={props.message.tool_calls && props.message.tool_calls.length > 0}>
          <div class="mt-2 space-y-1 pt-2 border-t border-current/10">
            <For each={props.message.tool_calls}>
              {(tc) => (
                <div class="flex items-center gap-1.5 text-[11px] font-mono">
                  <Show
                    when={tc.ok}
                    fallback={<XCircle class="h-3 w-3 text-destructive" />}
                  >
                    <CheckCircle2 class="h-3 w-3 text-green-600" />
                  </Show>
                  <span class="opacity-80">{tc.name}</span>
                  <Show when={tc.error}>
                    <span class="text-destructive truncate">— {tc.error}</span>
                  </Show>
                </div>
              )}
            </For>
          </div>
        </Show>
      </div>
      <Show when={isUser()}>
        <div class="flex-shrink-0 mt-1">
          <User class="h-5 w-5 text-muted-foreground" />
        </div>
      </Show>
    </div>
  );
};
